<div class="compare-brand" *ngIf="brands && brands.length > 0">
	<h2 class="title-h2">{{ 'whatsIncludedSidebars.compareBrands.title.compareBrands' | ibeadmin: 'sync' }}</h2>

	<div class="border compare-brand--item " *ngFor="let brand of brands;let index = index">
		<div class="grid no-padding">
			<div class="col-4 col-tp-4 col-p-12 no-padding compare-brand--icon">
				<app-svg [ngClass]="['brand--'+brand.name]" svg="sprite.svg#brand--{{brand.name}}" attr.aria-label="{{brand.name + ' brand'}}" [alt]="brand.name + ' brand logo'"></app-svg>
			</div>
			<div class="col-8 col-tp-8 col-p-12">
				<p class="" [innerHTML]="INDRA_printLabel(brand)"></p>
			</div>
		</div>
	</div>

</div>
